import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart } from "../GlobalScript";
import { ShoppingCartContext } from './ShoppingCartContext';
import PrintableBackOrders from './PrintableBackOrders.js';
import { useReactToPrint } from 'react-to-print';
import Cookies from 'js-cookie';
import PaginationBar from '../PaginationBar';
import PulseLoader from "react-spinners/PulseLoader";
import CloseButton from 'react-bootstrap/CloseButton';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../FooterDealer.js';

export default function BackOrders() {

    //const navigate = useNavigate();
    const countPerPage = 25;
    const [pageResults, setPageResults] = useState(countPerPage);
    const [tempPage, setTempPage] = useState(countPerPage);
    const [resultsLength, setResultsLength] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [orderItems, setOrderItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [UserInfo, setUserInfo] = useState(null);
    const [activeRow, setActiveRow] = useState(null);
    const dropdownRef = useRef(null);
    const contentRef = useRef(null);
    const promiseResolveRef = useRef(null);
    const [isPrinting, setIsPrinting] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + pageResults;

    const pageCount = Math.ceil(orderItems.length / pageResults);
    const currentItems = orderItems.slice(itemOffset, endOffset);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);
    const [actionMap, setActionMap] = useState(new Map());
    const [qtyMap, setQtyMap] = useState(new Map());
    const [dropdownText, setDropdownText] = useState([]);
    const [pop, setPop] = useState(false);
    const [allItemsMap, setAllItemsMap] = useState(new Map());

    const [noticeType, setNoticeType] = useState(0);
    const [noticeItem, setNoticeItem] = useState('');
    const [noticeMsg, setNoticeMsg] = useState('');
    const [noticeModal, setNoticeModal] = useState(false);

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));
        document.title = 'K-Dealer - Back Orders';
    }, []);

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    const handleShowNoticeModal = (item, type) => {
        if (item && type) {
            setNoticeItem(item.itemNbr);
            setNoticeType(type);
        }
        setNoticeModal(true);
    };
    const handleCloseNoticeModal = () => {
        setNoticeModal(false);
        setNoticeItem('');
        setNoticeType(0);
        setNoticeMsg('');
        setDropdownText([]);
        setActionMap(new Map());
    };

    useEffect(() => {
        if (loading === true) {
            LoadOrders();
            handlePop();
        } else {
            handleClosePop();
        }
    }, [loading]);

    useEffect(() => {
        CheckSession();
        if (!UserInfo) {
            let ck = GetCoockie();
            setUserInfo(ck);
            window.GlobalLoading++;
        }
        if (window.GlobalLoading === 1) {
            window.location.reload();
        }
    }, [UserInfo])

    useEffect(() => {
        if (isPrinting && promiseResolveRef.current) {
            promiseResolveRef.current();
        }
    }, [isPrinting]);

    const handlePrintBackOrders = useReactToPrint({
        contentRef,
        onBeforeGetContent: () => {
            return new Promise((resolve, reject) => {
                if (!contentRef.current) {
                    reject(new Error('There is nothing to print'));
                } else {
                    promiseResolveRef.current = resolve;
                    setIsPrinting(true);
                }
            });
        },
        onAfterPrint: () => {
            promiseResolveRef.current = null;
            setIsPrinting(false);
        },
        onPrintError: (errorLocation, error) => {
            console.error('Print error at:', errorLocation, error);
            setTimeout(() => {
            }, 0);
        }
    });

    const tryPrintOrder = () => {
        if (orderItems.length === 0) {
            setErrorMsg(
                'There was an error while attempting to print the back orders list. Please try again later.'
            );
        } else {
            handlePrintBackOrders();
        }
    }

    const LoadOrders = async () => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                value: user.userKey.toString(),
                label: user.dealerID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetBackOrderList", requestOptions);
            if (response.status !== 200) {
                return;
            }
            const orders = await response.json();
            const map = new Map();
            orders.map((item) => {
                map.set(item.orderNbr + "," + item.itemNbr, item);
                updateQty(item, parseInt(item.bOQty));
                return '';
            });
            setAllItemsMap(map);
            setOrderItems(orders);
            setResultsLength(orders.length);
            setDropdownText(new Array(orders.length).fill(''));
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'tempPage') {
            setTempPage(value);
        }
    }

    const handlePageClick = (input) => {
        const pageIndex = typeof input === "number" ? input : input.selected;
        const newOffset = pageIndex * pageResults;
        setCurrentPage(pageIndex);
        setItemOffset(newOffset);
    };

    const changePageResults = () => {
        if (tempPage && tempPage > 0 && tempPage < 1000) {
            const newSize = Number(tempPage) || 1; // basic safety 
            setPageResults(newSize);
            setCurrentPage(0);
            setItemOffset(0);
        }
    };

    const handleUpdateItem = (item, type, index) => {
        updateActionCode(item, type, index);
        handleShowNoticeModal(item, type);
    }

    const updateActionCode = async (item, type, index) => {
        const id = item.orderNbr + "," + item.itemNbr;
        const acmap = new Map(actionMap);
        if (type <= 0 || type > 3) {
            acmap.delete(id);
        } else {
            acmap.set(id, type);
        }

        if (type === 0) {
            //reset
            setDropdownText((prevArray => {
                const updatedArray = [...prevArray];
                updatedArray[index] = '';
                return updatedArray;
            }));
        } else if (type === 1) {
            setDropdownText((prevArray => {
                const updatedArray = [...prevArray];
                updatedArray[index] = 'Cancel';
                return updatedArray;
            }));
        } else if (type === 2) {
            //retian
            //retain
            setDropdownText((prevArray => {
                const updatedArray = [...prevArray];
                updatedArray[index] = 'Retain';
                return updatedArray;
            }));
        } else if (type === 3) {
            //modify
            setDropdownText((prevArray => {
                const updatedArray = [...prevArray];
                updatedArray[index] = 'Modify';
                return updatedArray;
            }));
        }
        setActionMap(acmap);
    }

    const updateQty = async (item, qtyValue) => {
        //setTempBOQty(qtyValue)
        const map = new Map(qtyMap);
        map.set(item.orderNbr + "," + item.itemNbr, qtyValue);
        setQtyMap(map);
    }

    const getActionCode = (type, index) =>{
        if (type === 1) {
            return "C";
        } else if (type === 2) {
            return "R";
        } else if (type === 3) {
            return "M";
        } else {
            return "";
        }
    }

    const handleUpdate = async () => {
        try {
            handleCloseNoticeModal();
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const arr = [];

            actionMap.forEach((value, key) => {
                console.log(`Key: ${key}, Value: ${value}`);
                const actionCode = actionMap.get(key);
                const copiedObject = { ...allItemsMap.get(key), "actionCode": getActionCode(actionMap.get(key)) };
                if (actionCode === 3 && qtyMap.has(key)) {
                    copiedObject.bOQty = qtyMap.get(key).toString();
                }
                arr.push(copiedObject);
            });
            const data = {
                dealerID: user.dealerID,
                items: arr
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/UpdateBackOrder", requestOptions);
            if (response.status !== 200) {
                handleShowNoticeModal();
                setNoticeMsg(`There was an error while attempting to update the backorder for item # ${noticeItem}. Please try again later.`);
                return;
            }

            handleShowNoticeModal();
            setNoticeMsg(`Successfully updated backorder for item # ${noticeItem}.`);
            await LoadOrders();
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    return (
        <>
            <Container className="checkout-container main-container dealer-section">

                <style type="text/css" media="print">
                    {"\
                        @page { size: portrait; margin: 0.5in; }\
                    "}
                </style>

                <div style={{ display: 'none' }}>
                    <PrintableBackOrders
                        ref={contentRef}
                        backorderItems={orderItems}
                        currentPage={currentPage}
                        pageResults={pageResults}
                    />
                </div>

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">BACK ORDERS</h1>
                    </Col>
                    <Col className="checkout-title-under"></Col>
                </Row>

                <Row className="mb-4">
                    <Col sm={12} className="text-right print-icon-container">
                        {orderItems && orderItems.length > 0 &&
                            <p className="bold mb-0" id="btnPrint">
                                <span className="svg-holder small-svg underline" onClick={() => tryPrintOrder()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 732.3 453.2">
                                        <g>
                                            <polyline className="st12 st14" points="398.6 139.6 398.6 53.8 564.5 53.8 603.1 89.5 603.1 139.6" />
                                            <polyline className="st13 st14" points="564.5 53.8 564.5 87.8 600.2 87.8" />
                                            <rect className="st10 st16 st17" x="337" y="139.6" width="322.6" height="156.7" rx="16.7" ry="16.7" />
                                            <rect className="st13 st14" x="377.3" y="238.7" width="241.3" height="35.1" rx="9.5" ry="9.5" />
                                            <rect className="st12 st14" x="398.6" y="257.7" width="201.6" height="182.6" />
                                            <rect className="st2" x="363.5" y="155.7" width="28.2" height="5.8" />
                                            <rect className="st2" x="339.3" y="209.3" width="320.3" height="11.5" />
                                            <rect className="st2" x="399.7" y="155.7" width="11.8" height="5.8" />
                                        </g>
                                    </svg>

                                    PRINT
                                </span>
                            </p>
                        }
                        {errorMsg &&
                            <p className="red">{errorMsg}</p>
                        }
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col sm={12}>
                                        <p className="bold mb-0">Please be aware that the dates shown here are a direct representation of what our representatives can see.</p>
                                        <p className="bold mb-0">****Due to current supply chain constraints some items may experience a longer than normal lead time.****</p>
                                        <p className="bold mb-0">CAUTION: Do not make firm customer commitments based on this information.</p>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-4 mb-4">
                    <Col sm={12}>
                        <Card className="">
                            <Card.Body>
                                <Row className="table-legend table-legend-sm mb-3">
                                    <Col sm={12} className="text-center">
                                        <span className="icons-row"><div className={`status-icon red-icon`} title="Purchase order has been submitted to supplier"></div> On Order</span>
                                        <span className="svg-holder">
                                            <img src="../../../Images/red-striped.svg" alt="red striped icon" title="Purchase order has been submitted to supplier but has not been fulfilled yet" className="mr-1" />
                                            On Order Past Due
                                        </span>
                                        <span className="icons-row"><div className={`status-icon yellow-icon`} title="Shipment is in transit and on time"></div> In Transit to KMC</span>
                                        <span className="svg-holder">
                                            <img src="../../../Images/yellow-striped.svg" alt="yellow striped icon" title="Shipment is in transit but experiencing a delay" className="mr-1" />
                                            In Transit to KMC - Past Due
                                        </span>
                                        <span className="svg-holder">
                                            <img src="../../../Images/green-striped.svg" alt="green striped icon" title="Incoming shipment has arrived at KMC warehouse" className="mr-1" />
                                            Dock Arrival
                                        </span>
                                        <span className="icons-row"><div className={`status-icon green-icon`} title="Parts have arrived at KMC and will allocate soon"></div> Available</span>
                                    </Col>
                                </Row>

                                <PaginationBar
                                    resultsLength={resultsLength}
                                    pageCount={pageCount}
                                    currentPage={currentPage}
                                    pageResults={pageResults}
                                    tempPage={tempPage}
                                    onTempPageChange={handleChange}
                                    onPageResultsChange={changePageResults}
                                    onPageChange={handlePageClick}
                                />

                                <Row>
                                    <Col sm={12} className="order-table">
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>ITEM # & <br />DESCRIPTION</th>
                                                    <th>ORDER <br /> ID</th>
                                                    <th>ORDER <br /> TYPE</th>
                                                    <th>MEMO</th>
                                                    <th>AVAILABILITY <br /> STATUS</th>
                                                    <th>EST. SHIP <br /> DATE</th>
                                                    <th>CANCEL <br /> DATE</th>
                                                    <th>PACKAGE <br /> QTY</th>
                                                    <th>BKORD <br /> QTY</th>
                                                    <th>SHIPPING <br /> METHOD</th>
                                                    <th>ACTION <br /> CODE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems && currentItems.map((item, index) => (
                                                    <tr key={item.orderNbr + item.itemNbr}>
                                                        <td>{(currentPage * pageResults) + index + 1}</td>
                                                        <td><span className="bold">{item.itemNbr}</span> <br /> {item.itemDesc}</td>
                                                        <td>{item.orderNbr}</td>
                                                        <td>{item.orderType}</td>
                                                        <td>{item.memo}</td>
                                                        {/*<td>{item.itemPOAvailabilityStatus}</td>*/}
                                                        <td className="table-legend-sm text-center">
                                                            {item.imgSource === '' ?
                                                                <span className="icons-row">
                                                                    <div className={item.className} title={item.title}></div>
                                                                </span>
                                                                : item.imgSource && item.imgAlt &&
                                                                <span className="svg-holder">
                                                                    <img src={item.imgSource} alt={item.imgAlt} title={item.title} />
                                                                </span>
                                                            }
                                                        </td>
                                                        <td>{item.estimatedShipDate}</td>
                                                        <td>{item.cancelDate}</td>
                                                        <td>{item.pkgQty}</td>
                                                        <td>
                                                            {item.bOQty > 1 ?
                                                                <DropdownButton
                                                                    variant="outline-dark"
                                                                    title={qtyMap.get(item.orderNbr + "," + item.itemNbr) || item.bOQty}
                                                                    id="backorder-qty"
                                                                    disabled={actionMap.get(item.orderNbr + "," + item.itemNbr) !== 3}
                                                                    className="limit-dropdown"
                                                                >                                                                    
                                                                    {item.bOQty > 1 &&
                                                                        Array.from({ length: item.bOQty }, (_, i) => {
                                                                            const qtyValue = item.bOQty - i;
                                                                            return (
                                                                                <Dropdown.Item key={i} onClick={() => updateQty(item, qtyValue)}>
                                                                                    <span className="bold">{qtyValue}</span>
                                                                                </Dropdown.Item>
                                                                            );
                                                                        })
                                                                    }
                                                                </DropdownButton>
                                                                :
                                                                <>
                                                                    {item.bOQty}
                                                                </>
                                                            }
                                                        </td>
                                                        <td>{item.shipInstructions}</td>
                                                        <td className="table-row" ref={dropdownRef} style={{ position: activeRow === item.orderNbr ? 'absolute' : 'static' }}>
                                                            <InputGroup>
                                                                <DropdownButton
                                                                    variant="outline-dark"
                                                                    title={dropdownText[index] || 'Actions'}
                                                                    id="input-group-dropdown-1"
                                                                >
                                                                    {/*{actionMap.get(item.orderNbr + "," + item.itemNbr) !== 0 &&*/}
                                                                    {/*    <Dropdown.Item><span className="bold" onClick={() => updateActionCode(item, 0, index)}>Actions</span></Dropdown.Item>*/}
                                                                    {/*}*/}

                                                                    {item.modifiable === true &&
                                                                        <Dropdown.Item onClick={() => handleUpdateItem(item, 3, index)}>
                                                                            <span className="bold">Modify</span>
                                                                        </Dropdown.Item>
                                                                    }

                                                                    <Dropdown.Item onClick={() => handleUpdateItem(item, 1, index)}>
                                                                        <span className="bold">Cancel</span>
                                                                    </Dropdown.Item>

                                                                    <Dropdown.Item onClick={() => handleUpdateItem(item, 2, index)}>
                                                                        <span className="bold">Retain</span>
                                                                    </Dropdown.Item>
                                                                </DropdownButton>
                                                            </InputGroup>
                                                        </td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>

                                <PaginationBar
                                    resultsLength={resultsLength}
                                    pageCount={pageCount}
                                    currentPage={currentPage}
                                    pageResults={pageResults}
                                    tempPage={tempPage}
                                    onTempPageChange={handleChange}
                                    onPageResultsChange={changePageResults}
                                    onPageChange={handlePageClick}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>

            <FooterDealer />

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <Modal show={noticeModal} onHide={handleCloseNoticeModal} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>NOTICE</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            {noticeMsg === '' ?
                                <p>Are you sure you want to {noticeType === 1 ? 'Cancel' : noticeType === 2 ? 'Retain' : 'Modify'} item # {noticeItem}?</p>
                            :
                                <p>{noticeMsg}</p>
                            }
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseNoticeModal}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        CLOSE
                    </Button>

                    {noticeMsg === '' &&
                        <Button variant="primary" onClick={handleUpdate}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            UPDATE
                        </Button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}